import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function InstagramAccountsForGirlies() {
  const { t } = useTranslation();

  const accounts = [
    {
      category: "Empowerment & Feminism",
      accounts: [
        {
          handle: "@florencegiven",
          name: "Florence Given",
          description: "Author and feminist artist sharing powerful messages about self-love, boundaries, and unlearning patriarchal conditioning. Her bold illustrations and captions will make you rethink everything.",
          why: "Perfect for daily reminders that you don't need to shrink yourself for anyone."
        },
        {
          handle: "@chiarablair",
          name: "Chiara Blair",
          description: "Intersectional feminist content about women's rights, body autonomy, and social justice. She breaks down complex topics into digestible, shareable content.",
          why: "Stay informed about women's issues globally with thoughtful, research-backed posts."
        },
        {
          handle: "@themindgeek",
          name: "The Mind Geek",
          description: "Psychology-based content about emotional intelligence, self-worth, and healthy relationships. Educational graphics that help you understand yourself better.",
          why: "Learn the psychology behind your patterns and how to break toxic cycles."
        }
      ]
    },
    {
      category: "Career & Financial Independence",
      accounts: [
        {
          handle: "@hersavvyway",
          name: "Her Savvy Way",
          description: "Personal finance for women breaking down investing, saving, and building wealth. No gatekeeping, just straightforward money advice.",
          why: "Financial literacy is feminist. Learn how to secure your financial future."
        },
        {
          handle: "@thefinancialdiet",
          name: "The Financial Diet",
          description: "Honest conversations about money, career, and adulting. They tackle everything from salary negotiation to budgeting with humor and realness.",
          why: "Normalize talking about money and learn practical financial skills."
        },
        {
          handle: "@girlboss",
          name: "Girlboss",
          description: "Career inspiration, entrepreneurship tips, and stories of successful women. Community-focused content celebrating female achievement.",
          why: "Get motivated by women who are crushing it in business and life."
        }
      ]
    },
    {
      category: "Mental Health & Wellness",
      accounts: [
        {
          handle: "@the.holistic.psychologist",
          name: "Dr. Nicole LePera",
          description: "Clinical psychologist sharing tools for healing, self-awareness, and breaking generational patterns. Deep, transformative content about inner work.",
          why: "Understand your nervous system, trauma responses, and how to heal."
        },
        {
          handle: "@nedratawwab",
          name: "Nedra Glover Tawwab",
          description: "Therapist and boundary expert. Her posts about setting boundaries, difficult conversations, and relationship dynamics are game-changing.",
          why: "Learn how to set boundaries without guilt (essential for every woman)."
        },
        {
          handle: "@sitwithwhit",
          name: "Whitney Goodman",
          description: "Therapist debunking toxic positivity and wellness myths. Refreshingly honest takes on mental health and therapy culture.",
          why: "Permission to not be okay and realistic approaches to mental health."
        }
      ]
    },
    {
      category: "Body Positivity & Self-Love",
      accounts: [
        {
          handle: "@mynameisjessamyn",
          name: "Jessamyn Stanley",
          description: "Yoga teacher promoting body liberation and dismantling wellness culture's exclusivity. Intersectional feminism meets radical self-acceptance.",
          why: "See what wellness looks like when it's truly inclusive and liberating."
        },
        {
          handle: "@i_weigh",
          name: "I Weigh",
          description: "Founded by Jameela Jamil, this account celebrates what makes us who we are beyond physical appearance. Body neutrality and radical acceptance.",
          why: "Shift focus from how you look to who you are and what you contribute."
        },
        {
          handle: "@beauty_redefined",
          name: "Beauty Redefined",
          description: "Twin PhDs researching body image. They expose how beauty standards harm women and offer tools for resilience.",
          why: "Understand how beauty standards are manufactured and how to resist them."
        }
      ]
    },
    {
      category: "Relationships & Dating",
      accounts: [
        {
          handle: "@mymatriarchs",
          name: "My Matriarchs",
          description: "Relationship advice centered on self-respect, standards, and not settling. Tough love combined with genuine care.",
          why: "Learn to recognize your worth in relationships and demand reciprocity."
        },
        {
          handle: "@levellingupshow",
          name: "Levelling Up",
          description: "Dating and relationship content focused on choosing partners wisely and building genuine self-worth first.",
          why: "Stop tolerating breadcrumbs and learn what healthy love actually looks like."
        },
        {
          handle: "@lizlistens",
          name: "Liz Moody",
          description: "Former wellness editor sharing research-backed relationship and communication advice. Practical tools for better connections.",
          why: "Evidence-based strategies for healthier relationships with everyone in your life."
        }
      ]
    },
    {
      category: "Social Justice & Activism",
      accounts: [
        {
          handle: "@soyouwanttotalkabout",
          name: "So You Want To Talk About",
          description: "Educational content breaking down complex social justice topics. Digestible infographics on intersectionality, racism, feminism, and more.",
          why: "Become a better ally and understand the interconnected nature of oppression."
        },
        {
          handle: "@feministmillennial",
          name: "Feminist Millennial",
          description: "Intersectional feminism simplified. Current events analyzed through a feminist lens with actionable steps.",
          why: "Stay informed about feminist issues and learn how to take action."
        },
        {
          handle: "@shityoushouldcareabout",
          name: "Shit You Should Care About",
          description: "Breaking news and social issues explained clearly. Politics, human rights, and current events without the jargon.",
          why: "Be an informed citizen and understand what's happening in the world."
        }
      ]
    },
    {
      category: "Life Skills & Personal Growth",
      accounts: [
        {
          handle: "@meganjaayne",
          name: "Megan Jayne",
          description: "Habit coach sharing practical tips for productivity, goal-setting, and building a life you love. No hustle culture toxicity.",
          why: "Learn sustainable habits that actually work for your real life."
        },
        {
          handle: "@thesecurerelationship",
          name: "The Secure Relationship",
          description: "Attachment theory explained. Understanding your attachment style and building secure relationships.",
          why: "Transform how you relate to yourself and others through attachment awareness."
        },
        {
          handle: "@manifestingbabe",
          name: "Manifesting Babe",
          description: "Law of attraction meets psychology. Practical manifestation techniques grounded in neuroscience and positive psychology.",
          why: "Learn to align your mindset with your goals (without toxic spirituality)."
        }
      ]
    },
    {
      category: "Creative & Inspiring Women",
      accounts: [
        {
          handle: "@rupikaur_",
          name: "Rupi Kaur",
          description: "Poet and artist sharing powerful pieces about femininity, trauma, healing, and love. Her work will move you to tears.",
          why: "Beautiful poetry that validates your experiences and emotions."
        },
        {
          handle: "@emmachamberlain",
          name: "Emma Chamberlain",
          description: "Authentic content about life, growing up, and figuring things out. Refreshingly real in an era of curated perfection.",
          why: "See someone being genuinely themselves without the highlight reel."
        },
        {
          handle: "@jannekaren",
          name: "Janne Robinson",
          description: "Writer and poet sharing raw, honest pieces about heartbreak, healing, and becoming who you're meant to be.",
          why: "Words that feel like they were written just for you."
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 py-20">
        <div className="absolute inset-0 bg-white/40"></div>
        <div className="container mx-auto px-6 relative z-10">
          <Link to="/blog" className="inline-flex items-center text-rose-600 hover:text-rose-700 mb-6 text-sm font-medium">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Blog
          </Link>
          
          <div className="max-w-4xl">
            <div className="flex items-center gap-3 mb-4">
              <span className="px-4 py-1.5 bg-purple-100 text-purple-700 rounded-full text-sm font-medium">
                Social Media
              </span>
              <span className="px-4 py-1.5 bg-rose-100 text-rose-700 rounded-full text-sm font-medium">
                Empowerment
              </span>
            </div>
            
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              30+ Social Media Accounts Every Woman Should Follow in 2025
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
              Curate a feed that empowers, educates, and inspires you. These accounts will change your perspective and support your growth journey.
            </p>
            
            <div className="flex items-center gap-6 text-sm text-gray-500">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>January 15, 2025</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>12 min read</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-user-line"></i>
                <span>SheCan Team</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-rose-50 to-purple-50 rounded-2xl p-8 mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Your Social Media Should Work FOR You
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Let's be real: social media can be toxic. But it can also be transformative when you follow the right people. Your feed should leave you feeling empowered, not inadequate. It should educate you, not just entertain you. It should make you think, grow, and challenge what you've been taught.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We've curated this list of must-follow accounts across different categories—from feminist activists to financial experts, from therapists to artists. These are women and allies who are using their platforms to create real change, share valuable knowledge, and build supportive communities.
            </p>
          </div>

          {/* Accounts by Category */}
          {accounts.map((category, idx) => (
            <div key={idx} className="mb-16">
              <div className="flex items-center gap-3 mb-8">
                <div className="h-1 w-12 bg-gradient-to-r from-rose-500 to-purple-500 rounded"></div>
                <h2 className="text-3xl font-bold text-gray-900">{category.category}</h2>
              </div>

              <div className="space-y-8">
                {category.accounts.map((account, accountIdx) => (
                  <div key={accountIdx} className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-all duration-300">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h3 className="text-2xl font-bold text-rose-600 mb-1">{account.handle}</h3>
                        <p className="text-lg text-gray-700 font-medium">{account.name}</p>
                      </div>
                      <div className="w-12 h-12 bg-gradient-to-br from-rose-100 to-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-instagram-line text-rose-600 text-xl"></i>
                      </div>
                    </div>
                    
                    <p className="text-gray-600 leading-relaxed mb-4">
                      {account.description}
                    </p>
                    
                    <div className="bg-purple-50 rounded-lg p-4 border-l-4 border-purple-500">
                      <p className="text-sm font-medium text-gray-700">
                        <strong className="text-purple-700">Why follow:</strong> {account.why}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Tips Section */}
          <div className="bg-gradient-to-br from-rose-500 to-purple-600 rounded-2xl p-10 text-white mb-12">
            <h2 className="text-3xl font-bold mb-6">How to Curate a Healthy Feed</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">Unfollow Without Guilt</h3>
                  <p className="text-white/90">If an account makes you feel worse about yourself, unfollow. Your mental health matters more than being polite.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">Diversify Your Feed</h3>
                  <p className="text-white/90">Follow people who don't look like you, think like you, or have your experiences. Growth happens outside echo chambers.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">Set Time Limits</h3>
                  <p className="text-white/90">Even the best content can become overwhelming. Use app timers and take regular breaks from social media.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">Engage Meaningfully</h3>
                  <p className="text-white/90">Don't just scroll. Save posts that resonate, share what helps you, and join the conversations in comments.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">Do Regular Audits</h3>
                  <p className="text-white/90">Every few months, review who you're following. Your needs and interests evolve—your feed should too.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Warning About Toxic Content */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-8 mb-12">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-alert-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Red Flags to Watch Out For</h3>
                <p className="text-gray-700 mb-4">Not all content is helpful. Be cautious of accounts that:</p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-amber-600 mt-1"></i>
                    <span>Promote extreme diets or unhealthy body standards</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-amber-600 mt-1"></i>
                    <span>Use fear-mongering or shame tactics instead of empowerment</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-amber-600 mt-1"></i>
                    <span>Promise quick fixes or magic solutions to complex problems</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-amber-600 mt-1"></i>
                    <span>Constantly push expensive products or courses without genuine value</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-amber-600 mt-1"></i>
                    <span>Dismiss professional help in favor of their own methods</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Final Thoughts */}
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Your Digital Space, Your Rules</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Remember: you have complete control over what you consume online. Social media algorithms want to keep you scrolling, but you get to decide what's worth your time and energy. These accounts are a starting point—a way to transform your feed from a source of comparison and anxiety into a tool for growth and empowerment.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              The women and allies on this list are doing important work. They're challenging systems, sharing knowledge that was gatekept for too long, and building communities where women support each other. By following them, you're not just passively consuming content—you're participating in a movement.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              As you explore these accounts, pay attention to how they make you feel. Do you feel inspired to take action? Do you learn something new? Do you feel less alone in your experiences? That's the content worth keeping. Everything else? Unfollow without guilt.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Your feed should be a reflection of the woman you're becoming, not a highlight reel that makes you feel inadequate. Choose wisely, engage thoughtfully, and remember that real life happens offline too. Social media is a tool—use it intentionally.
            </p>
          </div>

          {/* Call to Action */}
          <div className="mt-16 bg-gradient-to-r from-rose-50 via-pink-50 to-purple-50 rounded-2xl p-10 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Found This Helpful?
            </h3>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
              Share this list with your friends and help them curate feeds that empower rather than diminish. Follow us on social media for more resources, and join our community of women supporting women.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link 
                to="/community" 
                className="px-8 py-3 bg-gradient-to-r from-rose-500 to-purple-600 text-white rounded-lg font-medium hover:shadow-lg transition-all duration-300"
              >
                Join Our Community
              </Link>
              <Link 
                to="/blog" 
                className="px-8 py-3 bg-white text-gray-900 rounded-lg font-medium border-2 border-gray-200 hover:border-rose-500 transition-all duration-300"
              >
                Read More Articles
              </Link>
            </div>
          </div>

          {/* Share Section */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-center text-gray-600 mb-4 font-medium">Share this article</p>
            <div className="flex justify-center gap-4">
              <button className="w-12 h-12 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-600 hover:text-white transition-colors duration-300 flex items-center justify-center">
                <i className="ri-facebook-fill text-xl"></i>
              </button>
              <button className="w-12 h-12 rounded-full bg-sky-100 text-sky-600 hover:bg-sky-600 hover:text-white transition-colors duration-300 flex items-center justify-center">
                <i className="ri-twitter-fill text-xl"></i>
              </button>
              <button className="w-12 h-12 rounded-full bg-pink-100 text-pink-600 hover:bg-pink-600 hover:text-white transition-colors duration-300 flex items-center justify-center">
                <i className="ri-instagram-line text-xl"></i>
              </button>
              <button className="w-12 h-12 rounded-full bg-green-100 text-green-600 hover:bg-green-600 hover:text-white transition-colors duration-300 flex items-center justify-center">
                <i className="ri-whatsapp-line text-xl"></i>
              </button>
              <button className="w-12 h-12 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-600 hover:text-white transition-colors duration-300 flex items-center justify-center">
                <i className="ri-link text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}